export const CHECKOUT_URL =
  'https://checkout.ebookpoint.shop/cart/59888620568657:1'

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/svnLW9TDBRmGTVeetzDMQ2/Sistema_completo_para_ensenar_ciencia.png'

export const BACKGROUND_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/89863ff7-d639-483e-b553-58a04cce7e01.jpg'

export const SUPPORT_EMAIL = 'EbookDreamShop@gmail.com'

export const PRICE = '$22.900'
export const OLD_PRICE = '$52.000'

export const scrollToCompra = () => {
  const el = document.getElementById('compra')
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }
}
